import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "#fff",
  "fill-rule": "evenodd",
  stroke: "#000",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  viewBox: "0 0 240 240"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("g", {
      fill: "none",
      "stroke-linejoin": "miter",
      "stroke-width": "2"
    }, [
      _createElementVNode("path", { d: "M238.25.75H.75v237.5h237.5z" }),
      _createElementVNode("g", { "stroke-linecap": "butt" }, [
        _createElementVNode("path", { d: "m22.972.75 42.084 237.5m108.889 0L215.889.75M65.056.75 238.25 215.89M173.945.75.75 173.944m237.5 0L22.972 238.25M238.25 65.056.75 22.972m0 42.084L215.89 238.25M.75 215.889l237.5-192.917" })
      ])
    ], -1)
  ])))
}
export default { render: render }